<template>
  <div
    v-if="page && isTC"
    class="tc-page-loading"
  >
    <Loader />
  </div>
  <Loader
    v-else
    v-bind="$attrs"
  />
</template>

<script>
import Loader from '@components/Loader'

export default {
  components: {
    Loader
  },
  props: { page: { type: Boolean, default: false } },
  computed: {
    isTC() {
      return process.env.VUE_APP_SATELLITE === 'testcandidates'
    }
  }
}
</script>
